/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:12:37
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/steps.js
 */
export default {
    // steps组件
    steps: {
        direction: 'row',
        current: 0,
        activeColor: '#3c9cff',
        inactiveColor: '#969799',
        activeIcon: '',
        inactiveIcon: '',
        dot: false
    }
}
